__webpack_require__.p = "https://central.bcdvideo.com/alliance/";